export default "__VITE_ASSET__BgEmrSue__"